export class Contract {
  id: string;
  body: string;
  terms: string[];

  constructor(contract: any = {}) {
      this.id = contract.id || null;
      this.body = contract.body || '';
      this.terms = contract.terms || [];
  }
}



// WEBPACK FOOTER //
// ./src/classes/contract.ts